import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { formatNumber } from '~/utils/common';

import type { TypeReceiveRequestOrder } from '~/types/receive.types';

/**
 * [입고관리 > 입고요청관리] 입고요청등록 모달 > 2페이지 > 입고 예정 정보 테이블
 */
const getReceiveRegisterOrderInfoColumnDefs = ({ hasPermissionNFA }: { hasPermissionNFA: boolean }) => {
  const columnDefs: ColDef<TypeReceiveRequestOrder['items'][number]>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
      valueFormatter: ({ value }) => formatNumber(value),
    },
    {
      field: 'goodsCode',
      headerName: '상품코드',
      width: 150,
    },
    {
      hide: !hasPermissionNFA,
      field: 'nsid',
      headerName: 'NSID',
      width: 180,
    },
    {
      field: 'goodsName',
      headerName: '상품명',
      minWidth: 436,
      flex: 1,
    },
    {
      field: 'unit',
      headerName: '요청수량',
      width: 87,
      cellStyle: { textAlign: 'right' },
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeReceiveRequestOrder['items'][0], TypeReceiveRequestOrder['items'][0]['unit']>) => {
        return value ? formatNumber(value) : '-';
      },
    },
  ];

  return { columnDefs };
};

export default getReceiveRegisterOrderInfoColumnDefs;
